import React from 'react'
import PropTypes from 'prop-types'

// Lodash
import _isEmpty from 'lodash/isEmpty'
import _noop from 'lodash/noop'

// Components
import Label from '../label'
import ProgressBar from '../progressBar'
import CheckMarkOn from '../../../../lib/assets/icons/check-mark-on.svg'
import CheckMarkOff from '../../../../lib/assets/icons/check-mark-off.svg'

// Constants
import STATUSES from '../../../../constants/gettingStarted/taskStatuses'
import { EMPTY_OBJECT } from '../../../../constants/base.constants'

import styles from './task.module.scss'

const renderIcon = (status) => {
  if (status === STATUSES.COMPLETED) {
    return <img src={CheckMarkOn} className={styles.icon} />
  }
  return <img src={CheckMarkOff} className={styles.icon} />
}

const Task = (props) => {
  const {
    title,
    status,
    additional: { progress = EMPTY_OBJECT },
    renderTitle
  } = props
  return (
    <>
      <div className={styles.container}>
        {renderIcon(status)}
        <Label title={title} className={styles.taskTitle}>
          {title || renderTitle()}
        </Label>
      </div>
      {!_isEmpty(progress) && <ProgressBar {...progress} />}
    </>
  )
}

Task.propTypes = {
  title: PropTypes.string,
  status: PropTypes.string,
  additional: PropTypes.object,
  renderTitle: PropTypes.func
}

Task.defaultProps = {
  title: '',
  status: STATUSES.PENDING,
  additional: EMPTY_OBJECT,
  renderTitle: _noop
}

export default Task
